import $ from "jquery";

import './scroll-button.css';

$(function() {
  $('#scroll-button').on("click", onClickScrollButton);
  window.onscroll = onScroll;
});

const onClickScrollButton = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

const onScroll = () => {
  var btn = document.getElementById("scroll-button");
  if (btn) {
    if (document.body.scrollTop > 700 || document.documentElement.scrollTop > 700) {
      btn.style.display = "block";
    } else {
      btn.style.display = "none";
    }
  }
};